/**
 * This Enum is used to indicate the current status of an HTTP request.
 */
export enum RequestStatus {
  LOADING,
  SUCCESS,
  FAIL,
}
